import {timezoneSafeTimestamp} from '../core/time.js';

function required(value,label,max=4000){
  const text=String(value||'').trim();
  if(!text)throw new TypeError(label+' is required');
  if(text.length>max)throw new TypeError(label+' is too long');
  return text;
}

function optional(value,label,max=160){
  if(value==null||value==='')return null;
  return required(value,label,max);
}

function timestamp(value,label){
  return timezoneSafeTimestamp(value,label);
}

function idOrGenerated(value){
  const id=String(value||'').trim();
  if(id)return required(id,'id',128);
  const generated=globalThis.crypto?.randomUUID?.();
  if(generated)return generated;
  throw new TypeError('id is required when crypto.randomUUID is unavailable');
}

export function createLiveNote({
  id,
  userId,
  sessionId,
  capturedAt,
  text,
  stageId=null,
  itemId=null
}={}){
  return Object.freeze({
    id:idOrGenerated(id),
    userId:required(userId,'userId',128),
    sessionId:required(sessionId,'sessionId',128),
    capturedAt:timestamp(capturedAt,'capturedAt'),
    text:required(text,'text',4000),
    stageId:optional(stageId,'stageId',128),
    itemId:optional(itemId,'itemId',128)
  });
}

export function liveNoteToRow(value){
  const note=createLiveNote(value);
  return Object.freeze({
    id:note.id,
    user_id:note.userId,
    session_id:note.sessionId,
    captured_at:note.capturedAt,
    note:note.text,
    stage_id:note.stageId,
    item_id:note.itemId
  });
}

export function liveNoteFromRow(row={}){
  return createLiveNote({
    id:row.id,
    userId:row.user_id,
    sessionId:row.session_id,
    capturedAt:row.captured_at,
    text:row.note,
    stageId:row.stage_id,
    itemId:row.item_id
  });
}

export function orderLiveNotes(rows=[]){
  if(!Array.isArray(rows))throw new TypeError('rows must be an array');
  return Object.freeze([...rows]
    .map(createLiveNote)
    .sort((a,b)=>Date.parse(a.capturedAt)-Date.parse(b.capturedAt)||String(a.id).localeCompare(String(b.id))));
}
